export default __webpack_public_path__ + "static/media/OrangeCross.50134ecc.svg";